import { Box } from '@mui/material';
import type { PhotoItem } from '../../hooks/use-photo-manager';
import { PhotoCard } from './photo-card';

interface PhotoGridProps {
  items: PhotoItem[];
  onRemove: (id: string) => void;
}

export function PhotoGrid({ items, onRemove }: PhotoGridProps) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: 'repeat(2, 1fr)',
          sm: 'repeat(3, 1fr)',
          md: 'repeat(4, 1fr)',
        },
        gap: 2,
      }}
    >
      {items.map((item) => (
        <PhotoCard key={item.id} item={item} onRemove={onRemove} />
      ))}
    </Box>
  );
}
